import * as z from 'zod';

export const GraphicSvgSchema = z.object({
    idGraphic: z.number(),
    svg: z.string(),
});

export type GraphicSvg = z.infer<typeof GraphicSvgSchema>;

export const GraphicSchema = z.object({
    id: z.number(),
    name: z.string(),
    description: z.string(),
    mime: z.string(),
    source: z.string(),
    width: z.number(),
    height: z.number(),
    fixedWidth: z.number(),
    fixedHeight: z.number(),
    price: z.number(),
    priceRepeatApply: z.boolean(),
    size: z.number(),
    customers: z.boolean(),
});

export type Graphic = z.infer<typeof GraphicSchema>;
